import React from "react";
import Marquee from "react-fast-marquee";
import "./ImageCarousel.css"; // Import the updated CSS

const ImageCarousel = () => {
    // Dynamically import all images from the given directory
    const importAll = (requireContext) =>
    requireContext.keys().map(requireContext);

    const images = importAll(
        require.context("../../assets/images", false, /\.(png|jpe?g|svg|JPG)$/)
    );
    return (
    <Marquee className="carousel-container">
        { images.map((image, index) => (
            <div className="full-height-image" key={index}>
                <img
                    src={image}
                    alt={`Slide ${index + 1}`}
                />
            </div>
        ))}
    </Marquee>
    );
};

export default ImageCarousel;